module.exports = __webpack_public_path__ + "static/media/display-suite-07.f00cca75.png";